import { QueryParamMagentoFilterManager } from "~/modules/catalog/classes/QueryParamMagentoFilterManager";
import { BASE_SEARCH_QUERY_PARAMS_SCHEMA } from "~/modules/catalog/variables/BaseSearchSchema";
import { ProductSortOptionType } from "~/modules/settings/types";
import { calculateTotalPagesCount } from "~/modules/catalog/helpers";

export async function useMagentoCatalogPageData(
  categoryId: MaybeRef<string | undefined>,
) {
  const {
    queryVariables: filters,
    committedQueryVariables,
    commitPush,
    reset,
  } = useQueryParams({
    ...BASE_SEARCH_QUERY_PARAMS_SCHEMA,
    sort: new QueryParamStr<ProductSortOptionType>().setDefault(
      unref(categoryId)
        ? ProductSortOptionType.top
        : ProductSortOptionType.relevance,
    ),
    filter: new QueryParamMagentoFilterManager(),
  });

  const {
    catalogPending: pending,
    catalogError: error,
    productList,
    totalCount,
    refreshPage,
    isNoProducts,
  } = await useMagentoCatalog(
    categoryId,
    {
      queryVariables: filters,
      committedQueryVariables: committedQueryVariables as Ref<any>,
    },
    `catalog-${unref(categoryId)}`,
  );

  const selectedFilterCount = computed(
    () => filters.filter.selectedFilters().length,
  );

  const totalPages = computed<number>(() =>
    calculateTotalPagesCount(
      totalCount.value,
      committedQueryVariables.value.size,
    ),
  );

  const totalResultsFound = computed(() => totalCount.value);

  const isProductsAndFiltersNoResults = computed(
    () => isNoProducts.value && !filters.filter.filters.length,
  );

  function onFilterSensitiveDataChange(): void {
    filters.page = 1;
    commitPush();
  }

  return {
    filters,
    committedQueryVariables,
    commitPush,
    reset,
    pending,
    error,
    productList,
    totalResultsFound,
    totalPages,
    selectedFilterCount,
    isNoProducts,
    isProductsAndFiltersNoResults,
    onFilterSensitiveDataChange,
    refreshPage,
  };
}
